import * as api from '../connectivity/api.subscriptions';
import { call, put } from 'redux-saga/effects';
import { takeLatest } from 'redux-saga';
import * as types from '../constants/actionTypes';
import { browserHistory } from 'react-router';
import { showLoading, hideLoading } from 'react-redux-loading-bar';


export function* doRequestUpdateSubscriptions(action) {
    yield put(showLoading());

    yield put({
        type: types.REQUEST__STARTED,
        payload: {
            requestFrom: 'subscriptions.doRequestUpdateSubscriptions'
        }
    });

    try{
        const dropboxRole = yield call(api.updateSubscriptions, action.payload),
            dropboxId = dropboxRole.dropbox.id
        ;

        yield put({
            type: types.SUBSCRIPTIONS__UPDATE__REQUESTED__SUCCEEDED,
            payload: { dropboxId }
        });
    } catch (e) {
        yield put({
            type: types.SUBSCRIPTIONS__UPDATE__REQUESTED__FAILED,
            message: e.message
        });
    }

    yield put({
        type: types.REQUEST__FINISHED,
        payload: {
            requestFrom: 'subscriptions.doRequestUpdateSubscriptions'
        }
    });

    yield put(hideLoading());
}

export function* doRequestUpdateSubscriptionsSucceeded(action) {
    const { dropboxId } = action.payload;

    yield put({
        type: types.ADD_NOTIFICATION,
        payload: {
            message: "Email Notifications updated successfully",
            level: 'success'
        }
    });

    yield put({
        type: types.REQUEST__SUCCEEDED,
        payload: {
            requestFrom: 'subscriptions.doRequestUpdateSubscriptions'
        }
    });

    //redirect to home page and auto expand current dropbox
    browserHistory.push('/?expand=' + dropboxId);
}

export function* doRequestUpdateSubscriptionsFailed(action) {
    yield put({
        type: types.REQUEST__FAILED,
        payload: {
            requestFrom: 'subscriptions.doRequestUpdateSubscriptions'
        }
    });
}

export function* watchRequestUpdateSubscriptions() {
    yield* takeLatest(types.SUBSCRIPTIONS__UPDATE__REQUESTED, doRequestUpdateSubscriptions);
}

export function* watchRequestUpdateSubscriptionSucceeded() {
    yield* takeLatest(types.SUBSCRIPTIONS__UPDATE__REQUESTED__SUCCEEDED, doRequestUpdateSubscriptionsSucceeded);
}

export function* watchRequestUpdateSubscriptionsFailed() {
    yield* takeLatest(types.SUBSCRIPTIONS__UPDATE__REQUESTED__FAILED, doRequestUpdateSubscriptionsFailed);
}


/** WEBPACK FOOTER **
 ** ./src/sagas/subscriptions.saga.js
 **/